@let t = clock$ | async;
@let timezone = timezone$ | async;

@if (t && t > 0 && timezone) {
  <div class="time font18">
    {{t | momentTz:'HH:mm:ss':timezone}}
  </div>
}
